import React from "react";

import Box from "@mui/material/Box";
import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";

import { Row } from "@rui/Stack";

export const LegendLabel = styled<React.FC<TypographyProps>>((props) => (
  <Typography variant="bodySecondaryReg" {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.neutral[600],
}));

export const ToggleLabel = styled(LegendLabel)({
  minWidth: "100%",
});

export const Legend = styled(Box)(({ theme }) => ({
  width: "60px",
  margin: theme.spacing(0, 1),
  height: "8px",
  borderRadius: "4px",
  background: "linear-gradient(to right, #FD668E, #E9A751, #1AC8A0)",
}));

export const LegendItemContainer = styled(Row)(({ theme }) => ({
  border: `1px solid ${theme.palette.shades.neutral[50]}`,
  borderRadius: "8px",
  padding: theme.spacing(0.5, 1),
}));
